import request from "@/utils/request"
import { BASE_API } from '@/utils/consts'

export async function queryCategory(data) {
  return request(`${BASE_API}/category/list`, {
    method: 'POST',
    data
  })
}

export async function addCategory(data) {
  return request(`${BASE_API}/category/create`, {
    method: 'POST',
    data
  })
}

export async function getCategory(data) {
  return request(`${BASE_API}/category/show/${data.id}`)
}

export async function updateCategory(data) {
  return request(`${BASE_API}/category/update`, {
    method: 'PUT',
    data
  })
}

export async function deleteCategory(data) {
  return request(`${BASE_API}/category/delete/${data.id}`, {
    method: 'DELETE'
  })
}

export async function addProduct(data) {
  return request(`${BASE_API}/product/create`, {
    method: 'POST',
    data
  })
}

export async function updateProduct(data) {
  return request(`${BASE_API}/product/update`, {
    method: 'PUT',
    data
  })
}

export async function queryProducts(data) {
  return request(`${BASE_API}/product/list`, {
    method: 'POST',
    data
  })
}


export async function deleteProduct(data) {
  return request(`${BASE_API}/product/delete/${data.id}`, {
    method: 'DELETE',
  })
}

// 诊所商品类别列表

export async function queryProductType(data) {  
  return request(`${BASE_API}/category/clinic/list`, {
    method: 'POST',
    data
  })
}

// 添加商品类别
export async function addProductType(data) {  
  return request(`${BASE_API}/category/clinic/create`, {
    method: 'POST',
    data
  })
}

// 编辑商品类别
export async function updateProductType(data) {  
  return request(`${BASE_API}/category/update`, {
    method: 'PUT',
    data
  })
}

// 删除商品类别
export async function deleteProductType(data) {  
  return request(`${BASE_API}/category/delete/${data.id}`, {
    method: 'DELETE'
  })
}

// 添加商品
export async function saveProduct(data) {  
  return request(`${BASE_API}/product/clone`, {
    method: 'POST',
    data
  })
}

// 诊所商品列表

export async function queryClinicProduct(data) {  
  return request(`${BASE_API}/product/clinic/list`, {
    method: 'POST',
    data
  })
}

// 查看产品详情
export async function showProductDetail(data) {  
  return request(`${BASE_API}/product/show/${data.id}`)
}

// 发布下架商品
export async function lockProduct(data) {  
  return request(`${BASE_API}/product/lock/${data.id}`, {
    method: 'PUT'
  })
}

// 产品编码是否存在
export async function checkProductCodeExist(data) {  
  return request(`${BASE_API}/product/is_code_exist`, {
    data
  })
}

// 商品编码生成
export async function generateProductCode(data) {  
  return request(`${BASE_API}/product/generate_product_code`, {
    method: 'POST',
    data
  })
}

// 药品查询
export async function queryProductDrug(data) {  
  return request(`${BASE_API}/product/drug/list`, {
    method: 'POST',
    data
  })
}

export async function queryCategoryConfig(data) {
  return request(`${BASE_API}/product_performance_category/config/list`, {
    method: 'POST',
    data
  })
}

export async function querySetCategoryConfig(data) {
  return request(`${BASE_API}/product_performance_category/config/relate_product`, {
    method: 'POST',
    data
  })
}
